import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { isAdmin } from "../services/adminService";
import { useEffect, useState } from "react";

export default function AdminRoute({ children }) {
  const { currentUser, loading } = useAuth();

  const [admin, setAdmin] = useState(null); // null = checking

  useEffect(() => {
    const checkAdmin = async () => {
      if (loading) return;

      if (!currentUser) {
        setAdmin(false);
        return;
      }

      try {
        const result = await isAdmin();
        setAdmin(result);
      } catch (err) {
        console.error(err);
        setAdmin(false);
      }
    };

    checkAdmin();
  }, [currentUser, loading]);

  if (loading || admin === null) {
    return <h2>Loading...</h2>;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (!admin) {
    return <Navigate to="/access-denied-admin" replace />;
  }

  return children;
}
